import { OrderCancellationPoliciesService } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { CreateUpdateOrderCancellationPolicyEntity } from '../../domain/entities/CreateUpdateOrderCancellationPolicyEntity'
import type { OrderCancellationPolicyEntity } from '../../domain/entities/OrderCancellationPolicyEntity'
import type { OrderCancellationPolicyHistoryEntity } from '../../domain/entities/OrderCancellationPolicyHistoryEntity'
import type { OrderCancellationPolicyHistoryFilterEntity } from '../../domain/entities/OrderCancellationPolicyHistoryFilterEntity'
import type { UpdateOrderCancellationPolicyStatusEntity } from '../../domain/entities/UpdateOrderCancellationPolicyStatusEntity'
import { OrderCancellationPolicyRepository } from '../../domain/repositories/OrderCancellationPolicyRepository'
import { CreateUpdateOrderCancellationPolicyModel } from '../models/CreateUpdateOrderCancellationPolicyModel'
import { OrderCancellationPolicyHistoryFilterModel } from '../models/OrderCancellationPolicyHistoryFilterModel'
import { OrderCancellationPolicyHistoryModel } from '../models/OrderCancellationPolicyHistoryModel'
import { OrderCancellationPolicyModel } from '../models/OrderCancellationPolicyModel'
import { UpdateOrderCancellationPolicyStatusModel } from '../models/UpdateOrderCancellationPolicyStatusModel'

export class OrderCancellationPolicyRepositoryImpl implements OrderCancellationPolicyRepository {
  async getPolicies(): Promise<OrderCancellationPolicyEntity[] | { error: true }> {
    try {
      const response = await OrderCancellationPoliciesService.getPoliciesAdmin()
      return response.map((item) => new OrderCancellationPolicyModel(item))
    } catch {
      return { error: true }
    }
  }

  async createPolicy(
    data: CreateUpdateOrderCancellationPolicyEntity
  ): Promise<OrderCancellationPolicyEntity | { error: true }> {
    const requestBody = new CreateUpdateOrderCancellationPolicyModel(data)
    try {
      const response = await OrderCancellationPoliciesService.createPolicyAdmin({ requestBody })
      return new OrderCancellationPolicyModel(response)
    } catch {
      return { error: true }
    }
  }

  async updatePolicy(
    id: number,
    data: CreateUpdateOrderCancellationPolicyEntity
  ): Promise<OrderCancellationPolicyEntity | { error: true }> {
    const requestBody = new CreateUpdateOrderCancellationPolicyModel(data)
    try {
      const response = await OrderCancellationPoliciesService.updatePolicyAdmin({ id, requestBody })
      return new OrderCancellationPolicyModel(response)
    } catch {
      return { error: true }
    }
  }

  async deletePolicy(id: number): Promise<{ success: true } | { error: true }> {
    try {
      await OrderCancellationPoliciesService.deletePolicyAdmin({ id })
      return { success: true }
    } catch {
      return { error: true }
    }
  }

  async updatePolicyStatus(
    id: number,
    data: UpdateOrderCancellationPolicyStatusEntity
  ): Promise<OrderCancellationPolicyEntity | { error: true }> {
    const requestBody = new UpdateOrderCancellationPolicyStatusModel(data)
    try {
      const response = await OrderCancellationPoliciesService.updatePolicyStatusAdmin({
        id,
        requestBody
      })
      return new OrderCancellationPolicyModel(response)
    } catch {
      return { error: true }
    }
  }

  async getHistory(
    filterData: OrderCancellationPolicyHistoryFilterEntity
  ): Promise<PaginateEntity<OrderCancellationPolicyHistoryEntity[]> | { error: true }> {
    const query = new OrderCancellationPolicyHistoryFilterModel(filterData)
    try {
      const response = await OrderCancellationPoliciesService.getHistoryAdmin(query)
      return new PaginateEntity<OrderCancellationPolicyHistoryEntity[]>(
        response,
        response.items?.map((item) => new OrderCancellationPolicyHistoryModel(item))
      )
    } catch {
      return { error: true }
    }
  }
}
